export const firebaseConfig = {
    apiKey: "AIzaSyCfRG1nDQpiqgg0TrwqRENn93nGcOdg7pA",
    authDomain: "unity-cloud-ci.firebaseapp.com",
    databaseURL: "https://unity-cloud-ci.firebaseio.com",
    projectId: "unity-cloud-ci",
    storageBucket: "unity-cloud-ci.appspot.com",
    messagingSenderId: "592615427178",
    appId: "1:592615427178:web:e23229c6f29c0095a50e13",
    measurementId: "G-V6RXL8Y81L"
};
